<onsip-header-main>
  <onsip-header-page-title>{{ "ONSIP_I18N.PARKING_LOT" | translate }}</onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if (hasParkingLots | async) {
  <onsip-header-main>
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input
          matInput
          [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_SEARCH"
          [formControl]="search"
          [placeholder]="'ONSIP_I18N.SEARCH' | translate"
          autocomplete="off"
        />
        <mat-icon color="primary" matSuffix>search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        [attr.data-cy]="E2eLocators.ADMIN_ADD_PARKING_LOT_BUTTON"
        color="primary"
        type="button"
        [routerLink]="views.ADMIN_PARKING_LOT_SETUP"
      >
        {{ "ONSIP_I18N.ADD_PARKING_LOT" | translate }}
      </button>
    </onsip-header-action-bar>
  </onsip-header-main>
  <onsip-table-two
    class="parking-lot-table"
    matSort
    matSortDirection="asc"
    matSortActive="name"
    multiTemplateDataRows
    [dataSource]="dataSource"
    [useGrid]="true"
    [trackBy]="trackById"
    [hoverable]="true"
  >
    <!-- menu name-->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.NAME" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let parkLot">
        <span class="text-ellipsis">
          {{ parkLot.name }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- extensions -->
    <ng-container matColumnDef="extensions">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.EXTENSIONS" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let parkLot">
        <span class="text-ellipsis">{{ (parkLot.extensions | formatExtensions).join(", ") }}</span>
      </mat-cell>
    </ng-container>
    <!-- numbers-->
    <ng-container matColumnDef="retrievalExtensions">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "ONSIP_I18N.RETRIEVAL_EXTENSIONS" | translate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let parkLot">
        <span class="text-ellipsis">{{
          (parkLot.retrieverExtensions | formatExtensions).join(", ")
        }}</span>
      </mat-cell>
    </ng-container>
    <!-- Action Column -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let parkLot">
        @if (selectedRows.includes(parkLot.advParkId)) {
        <mat-icon color="primary">expand_less </mat-icon>
        } @if (!selectedRows.includes(parkLot.advParkId)) {
        <mat-icon color="primary">expand_more </mat-icon>
        }
        <button
          mat-icon-button
          (click)="removeItem(parkLot, $event)"
          [attr.data-cy]="E2eLocators.ADMIN_ADD_PARKING_LOT_DELETE_BUTTON"
        >
          <mat-icon color="primary">delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- Expanded Shelf -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let parkLot"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(parkLot.advParkId)"
      >
        @if (selectedRows.includes(parkLot.advParkId)) {
        <onsip-parking-lot-shelf-container
          [parkLot]="parkLot"
          [parkChannelPrice]="parkChannelPrice"
        >
        </onsip-parking-lot-shelf-container>
        }
      </onsip-table-shelf-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_TABLE_ROW"
      (click)="
        selectedRows.includes(row.advParkId)
          ? selectedRows.splice(selectedRows.indexOf(row.advParkId), 1)
          : selectedRows.push(row.advParkId)
      "
    >
    </mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (!dataSource.data.length || !search.value) {
      <span
        translate
        [translateParams]="{ value: 'ONSIP_I18N.PARKING_LOT' | translate | lowercase }"
      >
        ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
      </span>
      } @if (search.value && dataSource.data.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    onsip-paginator-primary-icon
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  <span class="mat-body-2"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
  } @else {
  <onsip-parking-lot-empty-data
    [pricingText]="pricingText"
    [viewsLink]="views.ADMIN_PARKING_LOT_SETUP"
    [e2Locator]="E2eLocators.ADMIN_ADD_PARKING_LOT_BUTTON"
  ></onsip-parking-lot-empty-data>
  }
</onsip-loading-container>
